module.exports = __webpack_public_path__ + "img/electric_use_selected.14d6dfef.svg";